export const etape = {
  //consommation-datatable
  MDI_CHECKBOX_CIRCLE: 'mdi mdi-checkbox-blank-circle',
  MDI_MAGNIFY: 'mdi-magnify',
  ICON_PLUS: 'fa fa-eye',
  ICON_EDIT: 'fa fa-edit',
  ICON_TRASH: 'fa fa-trash',
};

export const of = {
  //detail-etape
  ICON_ANGLE_UP: 'fas fa-angle-up',
  ICON_ANGLE_DOWN: 'fas fa-angle-down',
  MDI_CHECKBOX_CIRCLE: 'mdi mdi-checkbox-blank-circle',
  ICON_PLAY: 'fas fa-play',
  ICON_THUMBS_UP: 'fas fa-thumbs-up',
  ICON_STOP: 'fas fa-stop',
  ICON_HOURGLASS: 'fas fa-hourglass',

  //datatable
  ICON_TASKS: 'fa fa-tasks',
  MDI_MAGNIFY: 'mdi-magnify',

  //Layout
  ICON_CALENDAR: 'far fa-calendar ',
  ICON_INFO_CIRCLE: 'fa fa-info-circle',
  ICON_USER: 'far fa-user',
  ICON_LIST: 'fa fa-list',
  ICON_TACHOMETER: 'fa fa-tachometer',
};

export const consommation = {
  ICON_PLUS: 'fas fa-plus',
  ICON_TRASH: 'fas fa-trash',
};

export const produitFini = {
  ICON_PLUS: 'fas fa-plus',
  ICON_TRASH: 'fas fa-trash',
};

export const produitSemiFini = {
  ICON_PLUS: 'fas fa-plus',
  ICON_TRASH: 'fas fa-trash',
};

export const edit = {
  ICON_ANGLE_UP: 'fas fa-angle-up',
  ICON_ANGLE_DOWN: 'fas fa-angle-down',

  //EditLayout
  ICON_PLUS: 'fas fa-plus',
  ICON_EYE: 'fa fa-eye',
  ICON_EDIT: 'fa fa-edit',
  ICON_PLAY: 'fas fa-play',
  ICON_THUMBS_UP: 'fas fa-thumbs-up',
  ICON_STOP: 'fas fa-stop',
  ICON_HOURGLASS: 'fas fa-hourglass',
  ICON_PAPERCLIP: 'fa fa-paperclip',
  ICON_CLOCK: 'fa fa-clock',
  MDI_CHECKBOX_CIRCLE: 'mdi mdi-checkbox-blank-circle',
  ION_CUBE: 'ion ion-md-cube',
};

export const show = {
  MDI_CHECKBOX_CIRCLE: 'mdi mdi-checkbox-blank-circle',
  ICON_CALENDAR: 'far fa-calendar ',
  ICON_USER: 'far fa-user ',
  ICON_ANGLE_UP: 'fas fa-angle-up',
  ICON_INFO_CIRCLE: 'fa fa-info-circle',
  ICON_PLAY: 'fas fa-play',
  ICON_THUMBS_UP: 'fas fa-thumbs-up',
  ICON_STOP: 'fas fa-stop',
  ICON_HOURGLASS: 'fas fa-hourglass',
  ICON_ANGLE_DOWN: 'fas fa-angle-down',

  //showLayout
  ICON_PLUS: 'fas fa-plus',
  ICON_EDIT: 'fa fa-edit',
  ICON_EYE: 'fa fa-eye',
  ICON_PAPERCLIP: 'fa fa-paperclip',
  ICON_CLOCK: 'fa fa-clock',
  ION_CUBE: 'ion ion-md-cube',
};
